"use client";

// packages/eden-icons/src/generated-from-source/Happy.jsx
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
var Happy = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", clipRule: "evenodd", fillRule: "evenodd", children: " " }),
  /* @__PURE__ */ jsx("path", { fill: color, d: "M17 9.5C17 10.33 16.33 11 15.5 11C14.67 11 14 10.33 14 9.5C14 8.67 14.67 8 15.5 8C16.33 8 17 8.67 17 9.5ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11Z", clipRule: "evenodd", fillRule: "evenodd", children: " " }),
  /* @__PURE__ */ jsx("path", { fill: color, d: "M12 18.25C14.3646 18.25 16.4225 16.9368 17.4843 15C17.7996 14.4248 17.5 14 17 14H7C6.5 14 6.24163 14.5 6.51573 15C7.57748 16.9368 9.63539 18.25 12 18.25Z", children: " " })
] });
var Happy_default = Happy;
export {
  Happy_default as default
};
